const COMPANIES_CACHE_KEY = "companies"
const COMPANIES_CACHE_TIME_KEY = "companies_cached_at"

export const clearCompaniesCache = () => {
  localStorage.removeItem(COMPANIES_CACHE_KEY)
  localStorage.removeItem(COMPANIES_CACHE_TIME_KEY)
}

export const getCompaniesCache = () => {
  const rawCompanies = localStorage.getItem(COMPANIES_CACHE_KEY)

  if (!rawCompanies) {
    return []
  }

  try {
    const companies = JSON.parse(rawCompanies)
    return Array.isArray(companies) ? companies : []
  } catch (e) {
    clearCompaniesCache()
    return []
  }
}

export const hasValidCompaniesCache = () => {
  const rawCompanies = localStorage.getItem(COMPANIES_CACHE_KEY)

  if (!rawCompanies) {
    return false
  }

  try {
    return Array.isArray(JSON.parse(rawCompanies))
  } catch (e) {
    clearCompaniesCache()
    return false
  }
}

export const setCompaniesCache = (companies) => {
  localStorage.setItem(COMPANIES_CACHE_KEY, JSON.stringify(companies))
  localStorage.removeItem(COMPANIES_CACHE_TIME_KEY)
}
